import { RcFile } from "antd/lib/upload";
import CryptoJS from "crypto-js";
import { debounce } from "lodash";
import { CONSTANT, SALT } from "./Constant";
import moment from "moment";
import { notification } from "antd";

export const Constant = {
  API_KEY: "secret-api-key",
};

export const uploadedFileOnPreview = async (file: any) => {
  let src = file.url as string;
  if (!src) {
    src = await new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj as RcFile);
      reader.onload = () => resolve(reader.result as string);
    });
  }

  const image = new Image();
  image.src = src;
  const imgWindow: any = window.open(src);
  imgWindow.document.write(image.outerHTML);
};

const insertAt = (array: any[], index: number, ...elementsArray: any[]) => {
  array.splice(index, 0, ...elementsArray);
};

export const convertTextToID = (
  textArray: any,
  mainArray: any,
  textKey = "name",
  idKey = "id"
) => {
  const newArray: any = [];
  if (textArray && textArray.values && textArray.values.length > 0) {
    textArray.values.forEach((x: any) => {
      const temp = mainArray.find((y: any) => y[textKey] === x);
      if (x && temp) {
        newArray.push(temp[idKey]);
      } else {
        insertAt(newArray, 0, x);
      }
    });
  }

  return newArray;
};

export const copyTextToClipboard = (textToCopy: any) => {
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard api method'
    return navigator.clipboard.writeText(textToCopy);
  } else {
    // text area method
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    // make the textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise<void>((res, rej) => {
      // here the magic happens
      document.execCommand("copy") ? res() : rej();
      textArea.remove();
    });
  }
};

export const stringEncryption = (string: string) => {
  return CryptoJS.AES.encrypt(string, Constant.API_KEY)
    .toString()
    .replace(/\+/g, "xMl3Jk")
    .replace(/\//g, "Por21Ld")
    .replace(/=/g, "Ml32");
};

export const stringDecryption = (string: string) => {
  string = string
    .replace(/xMl3Jk/g, "+")
    .replace(/Por21Ld/g, "/")
    .replace(/Ml32/g, "=");
  return CryptoJS.AES.decrypt(string, Constant.API_KEY).toString(
    CryptoJS.enc.Utf8
  );
};

export const dataToFormDataConverter = (data: any) => {

  const formData = new FormData();
  for (let name in data) {
    const value = data[name];

    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        name = `${name}[]`;
        value.map(item => {
          formData.append(name, item);
          return item;
        });
      } else {
        formData.append(name, value);
      }
    }
    // formData.append(name, data[name]); // there should be values.avatar which is a File object
  }

};

export const b64toBlob = (b64Data: any, contentType: any, sliceSize: any) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

// Function use to validate form fields
export const validateFields = debounce((form, setDisabled) => {
  form
    .validateFields()
    .then(() => {
      setDisabled(false);
    })
    .catch(() => {
      setDisabled(true);
    });
}, 500);

export const dateFormatter = (
  date: any,
  format = CONSTANT.DATE_TIME_FORMAT
) => {
  return moment(date).format(format);
};

export const snakeCaseString = (str: any): string => {
  return (
    str &&
    str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map((s: any) => s.toLowerCase())
      .join("_")
  );
};

export const camelCaseString = (str: string): string => {
  str = str
    .replace(/[-_]+/g, " ")
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word: any, index: any) {
      return index !== 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/ (.)/g, function ($1: any) {
      return $1.toUpperCase();
    });
  return str;
};

/**
 * We use notification from here 2 type of nofiifcation
 * Success: {placement:"bottomRight",message: "Your Success message"}
 * Error: {placement:"bottomRight",message: "Your Error Message"}
 */
export const Notification = {
  success: (data: any) => {
    notification.success({
      placement: data.placement ? data.placement : "top",
      duration: 7,
      ...data,
      style: {
        minHeight: 50,
        minWidth: 230,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    });
  },
  error: (data: any) => {
    notification.error({
      placement: data.placement ? data.placement : "top",
      duration: 7,
      ...data,
      style: {
        minHeight: 50,
        minWidth: 230,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    });
  },
};

// function to check user privileges
export const checkPrivileges = (
  userDetail: any,
  permissionType: string
): boolean =>
  !!(
    userDetail?.userPrivileges &&
    userDetail?.userPrivileges.includes(permissionType)
  );

export const mobilePattern = (str: any) => {
  const cleanedValue = str.replace(/[^\d]/g, '');

  // Format the cleaned value as "###-###-####."
  const formattedValue = cleanedValue.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  return formattedValue;

}

// Functions to set html content in react component
export const contentMarkup = (data: any) => {
  return { __html: `<p>${data}</p>` }
}
export const contentMarkupWithClass = (classname: any, description: any) => {
  return { __html: `<p class=${classname}>${description}</p>` }
}
export const contentMarkupHeader = (classname: any, data: any) => {
  return { __html: `<h4 class=${classname}>${data}</h4>` }
}



// encode_decode_base64
export const base64EncodeDecode = (
  type: any = 'encode',
  string: string,
  salt: any = SALT
) => {
  try {

    if (type == 'encode') {
      // const words = CryptoJS.enc.Utf8.parse(string+'salt'); // WordArray object
      const words = btoa(string + salt); // WordArray object
      return { status: true, data: words };
    }
    else {
      const words = atob(string);
      // return {status:true,data:CryptoJS.enc.Utf8.stringify(words)};
      return { status: true, data: words.replaceAll(salt, '') };
    }
  }
  catch (err: any) {
    console.error('en', err);
    return { status: false, data: '', error: err.message };
  }
};


export const get_users_industry = (userDetail: any) => {
  let is_solar = false;
  let is_wind = false;
  if (userDetail != null) {
    is_wind = userDetail.industry_id == 3;
    is_solar = userDetail.industry_id == 1;
  }
  return { is_solar, is_wind }
}





export const setAddClassInputAnimation = () => {
  const formitems = document.querySelectorAll('.ecn-input');
  formitems.forEach((formitem: any) => {
    const inputRow = formitem.querySelector('.ant-form-item-row');
    inputRow.classList.add('focused');
  });
}
export const setResetInputAnimation = (set: any = true) => {
  const formitems = document.querySelectorAll('.ecn-input:not(.active)');

  if (formitems.length > 0) {
    if (set) {
      formitems.forEach((formitem: any) => {
        const inputRow = formitem.querySelector('.ant-form-item-row');
        var input = formitem.querySelector('input');
        var textarea = formitem.querySelector('textarea');
        const select = formitem.querySelector('.ant-select');
        // Input Handling
        if (input && inputRow) {
          if (input.value !== '') {
            inputRow.classList.add('focused');
          }
          input.addEventListener('focus', () => {
            inputRow.classList.add('focused');
          });
          input.addEventListener('blur', (e: any) => {
            if (e.target.value === '') {
              inputRow.classList.remove('focused');
            }
          });
        }

        if (textarea && inputRow) {
          if (textarea.value !== '') {
            inputRow.classList.add('focused');
          }

          textarea.addEventListener('focus', () => {
            inputRow.classList.add('focused');
          });

          textarea.addEventListener('blur', (e: any) => {
            if (e.target.value === '') {
              inputRow.classList.remove('focused');
            }
          });
        }

        // Select Handling
        if (select && inputRow) {
          const selector = select.querySelector('.ant-select-selector');

          const updateFocusedState = () => {
            const selected = select.querySelector('.ant-select-selection-item')?.textContent;
            if (selected && selected.trim() !== '') {
              inputRow.classList.add('focused');
            } else {
              inputRow.classList.remove('focused');
            }
          };

          // Initially set if value is present
          updateFocusedState();

          selector?.addEventListener('focus', () => {
            inputRow.classList.add('focused');
          });

          selector?.addEventListener('blur', () => {
            updateFocusedState();
          });

          // Also observe DOM mutation for selection change
          const observer = new MutationObserver(updateFocusedState);
          // const observer = new MutationObserver(()=>{console.log('select')});
          const target = select.querySelector('.ant-select-selector');
          if (target) {
            observer.observe(target, { childList: true, subtree: true });
          }
        }
      });

    }
    else {
      formitems.forEach((formitem: any) => {
        const input = formitem.querySelector('input');
        if (input) {
          input.removeEventListener('focus', () => { console.log("") });
          input.removeEventListener('blur', () => { console.log("") });
        }
      });
    }
  }

  // const formitemsselected = document.querySelectorAll('.ecn-input.active');

  // if (formitemsselected.length > 0) {
  //   formitemsselected.forEach((formitem: any) => {
  //     const inputRow = formitem.querySelector('.ant-form-item-row');
  //     inputRow.classList.add('focused');
  //   });


  // }





}
export const formatGlobalPrice = (price: any, symbol = '$') => {
  if (price == null) {
    return `${symbol}0.00`;
  }

  // Convert price to a number and then format with commas
  const numericPrice = parseFloat(price);
  if (isNaN(numericPrice)) {
    return `${symbol}0.00`; // Handle cases where price isn't a valid number
  }

  return `${symbol}${numericPrice.toLocaleString('en-US', {
    minimumFractionDigits: 0, // No decimal places for whole numbers
    maximumFractionDigits: 2 // Up to two decimal places for cents
  })}`;
};


export const SvgToBase64 = (svgElement: SVGSVGElement) => {
  const serializer = new XMLSerializer();
  let svgString = serializer.serializeToString(svgElement);

  // Ensure the SVG has the xmlns attribute
  if (!svgString.includes('xmlns="http://www.w3.org/2000/svg"')) {
    svgString = svgString.replace(
      /^<svg/,
      '<svg xmlns="http://www.w3.org/2000/svg"'
    );
  }

  // Encode SVG string into Base64 (safe for UTF-8)
  const encoded = btoa(
    encodeURIComponent(svgString).replace(
      /%([0-9A-F]{2})/g,
      (_, p1) => String.fromCharCode(parseInt(p1, 16))
    )
  );

  return `data:image/svg+xml;base64,${encoded}`;
}



export const setCookie = (name: string, value: string, days: number = 60) => {
  const date = new Date();
  // Set the number of days for the cookie to last
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); //days dynamic
  // date.setTime(date.getTime() + (2 * 24 * 60 * 60 * 1000)); //2 days
  // date.setTime(date.getTime() + (15 * 60 * 1000)); //15 minutes
  const expires = "expires=" + date.toUTCString();

  // Construct the cookie string
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};



export const getCookie = (name: string) => {
  // Add an equals sign to the cookie name for easy searching
  const cookieName = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  // Loop through the array to find the cookie
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    // Trim leading whitespace
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    // Check if the cookie starts with the name we're looking for
    if (cookie.indexOf(cookieName) === 0) {
      // Return the value of the cookie
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return ""; // Return an empty string if the cookie is not found
};


export const clearCookie = (name: string) => {
  // Set the cookie with a past expiration date
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
};

export const postFormDataSubmit = (url: string, data: any) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;

  Object.keys(data).forEach((key) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = data[key] || "";
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit(); // 🚀 Redirect happens here
}
